import { useEffect } from 'react';

import { useEditorNode, useNodeContext } from 'craft/hooks';

import { useFormAncestor } from './useFormAncestor';

export const useFormIdFromAncestor = (formId?: string) => {
  const { id } = useNodeContext();
  const { formId: ancestorFormId } = useFormAncestor(id);
  const { setProps } = useEditorNode(id);

  // if the form elements dont have a form id
  useEffect(() => {
    if (!formId || formId !== ancestorFormId) {
      setProps({ formId: ancestorFormId });
    }
  }, [formId, ancestorFormId]);
};
